import {AnswerTemplateAggregate} from "../aggregates";
import {Observable} from "rxjs";

export abstract class AnswerTemplateGateway {

  abstract create(answerTemplate: AnswerTemplateAggregate): Observable<AnswerTemplateAggregate>;

  abstract list(companiesIds: Array<string>): Observable<Array<AnswerTemplateAggregate>>;

  abstract update(answerTemplate: AnswerTemplateAggregate): Observable<AnswerTemplateAggregate>;

  abstract delete(id: number): Observable<null>;

}
